<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">Print Cover Note</h3>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 class="mt-3">
              <form>
                <v-expansion-panel expand :value="[true]">
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-icon>mdi-filter-variant</v-icon> Filters
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="intermediaryList" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="schemeList" v-model="filters.scheme" :label="filtersLabel.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="filtersLabel.scheme" :error-messages="errors.collect('scheme')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-autocomplete :items="planList" v-model="filters.plan" :label="filtersLabel.plan" item-text="label" item-value="value" data-vv-name="plan" :data-vv-as="filtersLabel.plan" :error-messages="errors.collect('plan')" clearable></v-autocomplete>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.coyName" :label="filtersLabel.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="filtersLabel.coyName" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field v-model="filters.coyName2" :label="filtersLabel.coyName2" :error-messages="errors.collect('coyName2')" data-vv-name="coyName2" :data-vv-as="filtersLabel.coyName2" v-validate="'name|max:60'"></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg6 xs6>
                              <cal-picker v-model="filters.acceptDateFrom" :label="filtersLabel.acceptDateFrom" :data-vv-as="filtersLabel.acceptDateFrom" data-vv-name="acceptDateFrom" :error-messages="errors.collect('acceptDateFrom')"></cal-picker>
                            </v-flex>
                            <v-flex xl3 lg6 xs6>
                              <cal-picker v-model="filters.acceptDateTo" :label="filtersLabel.acceptDateTo" :data-vv-as="filtersLabel.acceptDateTo" data-vv-name="acceptDateTo" :error-messages="errors.collect('acceptDateTo')"></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </form>
            </v-flex>
          </v-layout>
        </v-container>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="pt-2">
                <v-data-table :headers="listHeaders" :items="items" item-key="proposalNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText" v-model="selected" select-all>
                  <template slot="items" slot-scope="props">
                    <td width="50px">
                      <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                    </td>
                    <td v-for="column in selectedColumns" :key="column">
                      {{props.item[column]}}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex lg6 xs12>
                <v-checkbox v-model="reportForm.sendEmail" :label="labels.sendEmail" data-vv-name="sendEmail" :data-vv-as="labels.sendEmail"></v-checkbox>
              </v-flex>
              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle mandatory v-model="reportForm.format">
                  <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      totalItems: 0,
      columns: [
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Intermediary', value: 'intermediaryName' },
        { text: 'Occupation', value: 'scheme' },
        { text: 'Plan', value: 'plan' },
        { text: 'Company Name', value: 'coyName' },
        { text: 'Acceptance Date', value: 'acceptDate' }
      ],
      selectedColumns: ['proposalNo', 'intermediaryName', 'scheme', 'plan', 'coyName', 'acceptDate'],
      labels: {
        customName: 'Report Name',
        proposalNo: 'Proposal No.*',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?'
      },
      filters: {
        proposalNo: undefined,
        intermediary: undefined,
        scheme: undefined,
        plan: undefined,
        coyName: undefined,
        coyName2: undefined,
        acceptDateFrom: undefined,
        acceptDateTo: undefined
      },
      filtersLabel: {
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        scheme: 'Occupation',
        plan: 'Plan',
        coyName: 'Company Name',
        coyName2: 'Company Name 2',
        acceptDateFrom: 'Acceptance Date From',
        acceptDateTo: 'Acceptance Date To'
      },
      reportForm: {
        customName: undefined,
        format: undefined,
        sendEmail: false,
        selectedProposalNo: []
      },
      menu: {},
      intermediaryList: [],
      schemeList: [],
      planList: [],
      supportedFormat: [],
      submitting: false
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData()
    },
    'pagination.page': function (value) {
      this.fetchData()
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData()
    },
    'pagination.sortBy': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async doInit() {
      try {
        const apiURI = this.$store.state.reports.agencyReports.menu.packagePrintCN
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.intermediaryList = data.intermediaryList
            this.schemeList = data.schemeList
            this.planList = data.planList

            this.menu = extractMenu(result.data._links)
            this.fetchData()
          }
        }
      } catch (err) {
        throw err
      }
    },
    async fetchData() {
      const apiUrl = this.menu.proposalList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.acceptDateFrom) {
            massageFilters.acceptDateFrom = formatDisplayDateTime2(removeTime(massageFilters.acceptDateFrom))
          }
          if (massageFilters.acceptDateTo) {
            massageFilters.acceptDateTo = formatDisplayDateTime2(setEndTime(massageFilters.acceptDateTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              data.map(row => {
                if (row.acceptDate) {
                  row.acceptDate = this.formatDate(row.acceptDate)
                }
              })
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let postForm = []
          this.selected.sort(function (a, b) { return (a.proposalNo > b.proposalNo) ? 1 : ((b.proposalNo > a.proposalNo) ? -1 : 0) })
          this.selected.map(select => {
            postForm.push(select.proposalNo)
          })
          const expand = {
            customName: this.reportForm.customName,
            format: this.reportForm.format,
            sendEmail: this.reportForm.sendEmail,
            selectedProposalNo: postForm
          }
          await this.$http.post(apiURI, expand)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.proposalNo = null
      this.filters.intermediary = null
      this.filters.scheme = null
      this.filters.plan = null
      this.filters.coyName = null
      this.filters.coyName2 = null
      this.filters.acceptDateFrom = null
      this.filters.acceptDateTo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
